require('./retailLoanStepOne.scss');
require('./retailLoanStepOne.override.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');

// @core
const { formatText, FormattedText } = require('core/i18n').i18n;

//@commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKCalculationWaffer = require('components/commons/OKCalculationWaffer/OKCalculationWaffer');
// @components
const ContractLoanDueInformation = require('../../contractLoanDueInformation/contractLoanDueInformation');
const ContractLoanNumberSelector = require('../../contractLoanNumberSelector/contractLoanNumberSelector');

// @constants
const { PERCENTAGE_SYMBOL, EURO_TEXT } = require('constants/index');
const {
    contractEasyLoan: { PAYMENT_DAY_OTHER },
    retailLoanDoTaggin: { TAGGING_MONTHS, TAGGING_VIEW_INE },
} = require('../../../../loansConstants/index');

//@helpers
const { buildEventsWizardRetailLoan } = require('../../../../loansUtilities/loansHelper');

//@utilities
const { formatAmount, getFormattedString } = require('utilities/currencyHelper');
const UrlHelper = require('utilities/urlHelper');
const {
    recordLinkV2,
} = require('utilities/tagging');

class RetailLoanStepOne extends React.Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handlePreContractInformationDownload = this.handlePreContractInformationDownload.bind(this);
        this.setDefaultTerm = this.setSelectedTerm.bind(this);
    }

    componentDidMount() {
        const termValue = formatText('retailLoanStepOne-termFortyEightMonthsValue');
        this.setSelectedTerm(termValue);
    }

    componentWillReceiveProps(nextProps) {
        const { immRetailLoan } = nextProps;
        if (immRetailLoan.get("termError")) {
            UrlHelper.scrollTo(this.termSelector);
        }
    }

    setSelectedTerm(item) {
        const { immRetailLoan, customAmount, setTerm } = this.props;
        const selectedTerm = immRetailLoan.get('selectedTerm');

        if (selectedTerm !== item) {
            const eventAction = item + TAGGING_MONTHS;
            const customData = buildEventsWizardRetailLoan(immRetailLoan, eventAction);
            recordLinkV2(customData);
            setTerm(item, customAmount);
        }
    }

    handleChange(item) {
        this.setSelectedTerm(item);
    }

    handlePreContractInformationDownload() {
        const { downloadPreContractDocument, immRetailLoan } = this.props;
        const customData = buildEventsWizardRetailLoan(immRetailLoan, TAGGING_VIEW_INE);
        recordLinkV2(customData);
        downloadPreContractDocument();
    }

    buildBenefits() {
        const { immRetailLoan } = this.props;
        const tin = this.addPercentage(immRetailLoan.get('tin'));
        const tae = this.addPercentage(immRetailLoan.get('tae'));

        const mapper = (benefit, index) => {
            return (
                <div
                    key={`retail-loan-step-one-benefit-${index}`}
                    className="col-xs-6 retail-loan-step-one__benefit"
                >
                    <i className={`retail-loan-step-one__icon ${benefit.icon}`}></i>
                    <FormattedText
                        value={benefit.title}
                        className="retail-loan-step-one__benefit-title"
                    />
                    <span
                        className="retail-loan-step-one__separator"
                    >
                    </span>
                    <FormattedText value={benefit.text} injectedStrings={benefit.injectedStrings} />
                </div>
            );
        };

        const benefitsOne = [
            {
                icon: 'icon-0-euro',
                title: 'retailLoanStepOne-benefitOneTitle',
                text: 'retailLoanStepOne-benefitOneText'
            },
            {
                icon: 'icon-flexibilidad',
                title: 'retailLoanStepOne-benefitTwoTitle',
                text: 'retailLoanStepOne-benefitTwoText'
            }
        ];

        const benefitsTwo = [
            {
                icon: 'icon-compras-seguras',
                title: 'retailLoanStepOne-benefitThreeTitle',
                text: 'retailLoanStepOne-benefitThreeText'
            },
            {
                icon: 'icon-seguro-accidentes',
                title: 'retailLoanStepOne-benefitFourTitle',
                text: 'retailLoanStepOne-benefitFourText',
                injectedStrings: [tin, tae]
            }
        ];

        const rowOne = benefitsOne.map(mapper);
        const rowTwo = benefitsTwo.map(mapper);

        return (
            <div>
                <div className="row">
                    {rowOne}
                </div>
                <div className="row">
                    {rowTwo}
                </div>
            </div>
        );
    }

    addPercentage(value) {
        return formatAmount(value, 2).concat(' ', PERCENTAGE_SYMBOL);
    }

    buildTae() {
        const { immRetailLoan, taeTooltip } = this.props;
        const rawTae = immRetailLoan.get('tae');
        const tae = this.addPercentage(rawTae);
        const taeItem = {
            bodyText: tae,
            boldTitle: true,
            className: 'item-tae',
            information: taeTooltip,
            title: 'retailLoanCommon-tae',
            tooltipAlternativeIcon: true,
            tooltipModifier: 'dark-bg',
            tooltipOffset: [10, 0],
            tooltipType: 'custom'
        };

        return taeItem;
    }

    buildLoanInfo() {
        const { immRetailLoan } = this.props;

        const selectedItemId = immRetailLoan.get('purpose');
        const immProducts = immRetailLoan.get('products');
        const immSelectedItem = immProducts.find(immItem => selectedItemId === immItem.get('nid'));
        const title = immSelectedItem.get('title');

        return (
            <div>
                <FormattedText
                    value="retailLoanStepOne-title"
                    injectedStrings={[title]}
                    className="retail-loan-step-one__title"
                />
                <FormattedText
                    value="retailLoanStepOne-explanatoryTextPartOne"
                    className="retail-loan-step-one__explanatory-text"
                />
                <FormattedText
                    value="retailLoanStepOne-explanatoryTextPartTwo"
                    className="retail-loan-step-one__explanatory-text"
                />
                <FormattedText
                    value="retailLoanStepOne-commandText"
                    className="retail-loan-step-one__command-text"
                />
            </div>
        );
    }

    buildTerms() {
        const { immRetailLoan } = this.props;

        const selectedTerm = immRetailLoan.get('selectedTerm');
        const termError = immRetailLoan.get('termError');
        const termValueText = formatText('retailLoanStepOne-termFortyEightMonthsValue');
        const termValues = [termValueText] //immSelectedItem.get('field_term', []);

        return (
            <ContractLoanNumberSelector
                termValues={termValues}
                name="retailNumberSelector"
                optionStyle="retail-loan-step-one__options"
                componentStyle="retail-loan-step-one__selector"
                selectedValue={selectedTerm}
                onChange={this.handleChange}
                titleText="retailLoanStepOne-termTitle"
                titleStyle="retail-loan-step-one__term-title"
                errorState={termError}
            />
        );
    }

    buildWaffer() {
        const { immRetailLoan } = this.props;

        const selectedItemId = immRetailLoan.get('purpose');
        const immProducts = immRetailLoan.get('products');
        const immSelectedItem = immProducts.find(immItem => selectedItemId === immItem.get('nid'));

        const rawTin = immRetailLoan.get('tin');
        const tin = this.addPercentage(rawTin);
        let decimalsLength = immSelectedItem.get('field_total_product_price') - Math.floor(immSelectedItem.get('field_total_product_price'));
        const selectedAmount = getFormattedString({
            amount: immSelectedItem.get('field_total_product_price'),
            currency: EURO_TEXT,
            decimalsLength: decimalsLength > 0 ? 2 : 0
        });

        const installmentAmount = immRetailLoan.getIn(['installment', 'amount']);
        const installmentRaw = immRetailLoan.get('installment');
        const installment = (installmentAmount !== '') ? getFormattedString(installmentRaw) : '--';

        const paymentDayKey = PAYMENT_DAY_OTHER ? 'retailLoanCommon-anniversary' : '';
        const paymentDay = formatText(paymentDayKey);

        const taeItem = this.buildTae();

        const values = [
            {
                title: formatText('retailLoanCommon-selectedAmount'),
                bodyText: selectedAmount
            },
            {
                title: formatText('retailLoanCommon-anualTin'),
                bodyText: tin
            },
            taeItem,
            {
                title: formatText('retailLoanCommon-paymentDay'),
                bodyText: paymentDay
            }
        ];

        const content = immRetailLoan.get('isFetchingTae') ?
            (
                <LoadingSection />
            ) : (
                <OKCalculationWaffer
                    itemsList={values}
                    outstandedLabel={formatText('retailLoanSidebar-payment')}
                    outstandedText={installment}
                />
            );

        return (
            <div className="retail-loan-step-one__waffer" >
                {content}
            </div >
        );
    }

    render() {
        const { immRetailLoan } = this.props;
        const loanInfo = this.buildLoanInfo();
        const waffer = this.buildWaffer();
        const benefits = this.buildBenefits();
        const termSelector = this.buildTerms();

        return (
            <section className="retail-loan-step-one" ref={child => {
                this.termSelector = child;
            }}>
                {loanInfo}
                {termSelector}
                {waffer}
                {benefits}
                <div className="retail-loan-step-one__see-info text-right">
                    <OKButton
                        onClick={this.handlePreContractInformationDownload}
                        modifier="link-complementary"
                    >
                        <FormattedText value="retailLoanStepOne-normalizedEuropeanInformation" />
                    </OKButton>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <ContractLoanDueInformation
                            immRetailLoan={immRetailLoan}
                            title="gdprRetailLoan-title"
                            message="gdprRetailLoan-gdprRetailLoan_message1"
                            complementaryText="gdprRetailLoan-gdprRetailLoan_message2"
                        />
                    </div>
                </div>
            </section>
        );
    }
}

RetailLoanStepOne.propTypes = {
    immRetailLoan: PropTypes.object.isRequired,
    taeTooltip: PropTypes.object,
    setTerm: PropTypes.func.isRequired,
    customAmount: PropTypes.number.isRequired,
    downloadPreContractDocument: PropTypes.func.isRequired,
};

module.exports = RetailLoanStepOne;
